import * as ActionTypes from "./types";

export function incFabCount(payload) {
  return {
    type: ActionTypes.INC_FAB_COUNT,
    payload,
  };
}

export function decFabCount(payload) {
  return {
    type: ActionTypes.DEC_FAB_COUNT,
    payload,
  };
}

export function apiErrorNotified(payload) {
  return {
    type: ActionTypes.API_ERROR_NOTIFIED,
    payload,
  };
}
